import { apiClient } from 'api'
import { Team } from 'types'
import { TeamToLeague } from 'types/leagues'

type NewTeam = Omit<TeamToLeague, 'team'>

export const addTeamToLeague = (teamId: number, leagueId: number) =>
    apiClient.post<NewTeam>('/teams-to-leagues', {
        teamId,
        leagueId,
    })

export const getTeamsToLeague = (leagueId: number) =>
    apiClient.get<TeamToLeague[]>(`/teams-to-leagues/league/${leagueId}`)

export const deleteTeamFromLeague = (teamId: number, leagueId: number) =>
    apiClient.delete<Team>(`/teams-to-leagues/${teamId}/${leagueId}`)
